var _desc, _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocTempIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip236_20184"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame",
    rx: 0,
    width: 23,
    height: 23,
    transform: "translate(0.500000 0.500000)",
    fill: "white",
    fillOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Frame",
    rx: 0,
    width: 23,
    height: 23,
    transform: "translate(0.500000 0.500000)",
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip236_20184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.03 7.71L14.78 2.46C14.71 2.39 14.62 2.34 14.53 2.3C14.44 2.26 14.34 2.25 14.25 2.25L5.25 2.25C4.85 2.25 4.47 2.4 4.18 2.68C3.9 2.97 3.75 3.35 3.75 3.75L3.75 20.25C3.75 20.64 3.9 21.02 4.18 21.31C4.47 21.59 4.85 21.75 5.25 21.75L18.75 21.75C19.14 21.75 19.52 21.59 19.81 21.31C20.09 21.02 20.25 20.64 20.25 20.25L20.25 8.25C20.25 8.15 20.23 8.05 20.19 7.96C20.15 7.87 20.1 7.78 20.03 7.71ZM15 4.81L17.68 7.5L15 7.5L15 4.81ZM18.75 20.25L5.25 20.25L5.25 3.75L13.5 3.75L13.5 8.25C13.5 8.44 13.57 8.63 13.71 8.78C13.86 8.92 14.05 9 14.25 9L18.75 9L18.75 20.25Z",
    fill: "#1F0A35",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocTempIcon);
export default __webpack_public_path__ + "static/media/docTempIcon.e2932c146a9378476bf045f0e3331018.svg";
export { ForwardRef as ReactComponent };